<template>
	<div class="mt-4">
		<p class="overline">Rows</p>
		<FieldChoices :includeTitle="false" :question="question" choicesKey="rows"></FieldChoices>
		<p class="overline">Columns</p>
		<FieldChoices :includeTitle="false" :question="question" choicesKey="columns" :includeWidth="true"></FieldChoices>
		<v-row>
			<v-checkbox value="1" v-model="question.include_cell_text" label="Show text in cells"></v-checkbox>
		</v-row>
		<!-- <div v-if="question.include_cell_text"> -->
		<!-- <v-btn small class="ml-2 mt-4" value="1" @click="copyCellText" color="primary">Copy cell text</v-btn> -->
<!-- 		<table class="v-table" width="100%">
				<thead>
					<tr>
						<td>&nbsp;</td>
						<th class="grey--text" v-for="column in question.columns" :key="`${question.name}_${column.value}`">
							{{column.text}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in question.rows" :key="row.value" v-if="question.cells[row.value]">
						<td><span class="grey--text">{{row.text}}</span></td>
						<td v-for="column in question.columns" :key="`${question.name}_${row.value}_${column.value}`">
							<v-text-field class="ma-1" v-model="question.cells[row.value][column.value]"></v-text-field>
						</td>
					</tr>
				</tbody>
			</table> -->
		<!-- </div> -->
	</div>
</template>
<script>
	import FieldChoices from "@/components/survey/survey-builder/elements/FieldChoices";
	export default {
		name: "FieldMatrix", 
		props: {
			question: {type: Object} 
		},
		data: () => {
			return {
			}
		},
		computed: {
			include_cell_text(){
				return this.question.include_cell_text;
			}
		},
		components: {
			FieldChoices: FieldChoices
		}, 
		watch: {
			include_cell_text: {
				deep: true,
				handler(){
					if( this.question.include_cell_text ){
						var cells = this.question.cells || {};
						if( this.question.rows ){
							this.question.rows.forEach( (row) => {
								var columns = {};
								if( this.question.columns ){
									this.question.columns.forEach( c => {
										columns[c.value] = c.text;
									})
								}
								cells[row.value] = columns;							
							})
						}
						this.question.cells = cells;
					}
				}
			}
		}, 
		methods: {
			copyCellText(){
			}
		},
		created(){
		}
	}
</script>